import { useLazyQuery } from "@apollo/client/react";
import { useMemo, useState } from "react";
import { GET_PRE_LIQUIDACION } from "../../../data/graphQL/queries/PreLiquidacion/getPreLiquidacion";
import toast from "react-hot-toast";

export const useGetRows = (filters, setIsRefetchRequired) => {
    const [busquedaCompletada, setBusquedaCompletada] = useState(false);

    const [getPreLiquidacion, { data, loading }] = useLazyQuery(GET_PRE_LIQUIDACION, {
        fetchPolicy: 'no-cache',
    });

    const handleSearch = () => {
        if (!filters.idDelegacion) {
            toast.error("Debe seleccionar una delegación para realizar la búsqueda");
            return;
        }
        getPreLiquidacion({
            variables: {
                input: {
                    mes: filters.mes,
                    anio: filters.anio,
                    idTipoProfesional: filters.idTipoProfesional,
                    idDelegacion: filters.idDelegacion,
                    idEstado: filters.idEstado,
                    idsProfesionales: filters.idsProfesionales ?? []
                }
            }
        }).then(() => {
            setBusquedaCompletada(true);
            setIsRefetchRequired(false);
        });
    };

    const liquidacionesPorProfesional = useMemo(() => {
        const liquidaciones = data?.preLiquidacion?.valorEsperado ?? [];
        if (liquidaciones.length === 0) return [];

        return Object.values(
            liquidaciones.reduce((acc, liquidacion) => {
                const { idProfesional } = liquidacion;

                if (!acc[idProfesional]) {
                    acc[idProfesional] = {
                        idProfesional,
                        idEstadoLiquidacionProfesional: liquidacion.idEstadoLiquidacionProfesional,
                        profesionalData: {
                            id: idProfesional,
                            profesional: liquidacion.profesional,
                            sap: liquidacion.codigoSAPProfesional,
                            tieneHonorarioFidelizado: false,
                            observacionRechazo: liquidacion.observacionRechazo
                        },
                        liquidaciones: [],
                    };
                }

                if (liquidacion.tieneHonorarioFidelizado) {
                    acc[idProfesional].profesionalData.tieneHonorarioFidelizado = true;
                }

                acc[idProfesional].liquidaciones.push(liquidacion);
                return acc;
            }, {})
        );
    }, [data]);

    return {
        handleSearch,
        liquidacionesPorProfesional,
        loading,
        busquedaCompletada
    };
};